module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.firstName),
      expression: "formData.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.firstName.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre es requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lastName),
      expression: "formData.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.lastName.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El apellido es requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail "), (_vm.$v.formData.email.required && _vm.$v.formData.email.email && !_vm.$v.formData.email.isUnique) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El email ya existe")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.email.email && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El email es requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.telefonoCelular),
      expression: "formData.telefonoCelular"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.telefonoCelular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.telefonoCelular = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.telefonoFijo),
      expression: "formData.telefonoFijo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "De su área de trabajo"
    },
    domProps: {
      "value": (_vm.formData.telefonoFijo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.telefonoFijo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Interno")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.interno),
      expression: "formData.interno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.interno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.interno = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Área")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.area),
      expression: "formData.area"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.area = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Legajo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.legajo),
      expression: "formData.legajo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.legajo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.legajo = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Usuario "), (_vm.$v.formData.username.required && !_vm.$v.formData.username.isUnique) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre de usuario ya existe")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.username.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre de usuario es requerido")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.password.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El password debe contener por lo menos 6 caracteres")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Repetir contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.repeatPassword),
      expression: "formData.repeatPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.formData.repeatPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.repeatPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.repeatPassword.sameAsPassword && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe coincidir con el password")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickGuardar($event)
      }
    }
  }, [_vm._v("GUARDAR")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, [_c('li', [_vm._v("Administración")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', [_vm._v("Usuarios")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Crear usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("NUEVO USUARIO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("DATOS DE ACCESO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86165082"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/NewUser.vue
// module id = 1151
// module chunks = 5